import React, {useEffect, useRef, useState} from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import SoldOutModal from "./components/soldOut";
import { getEventPageDetailsById, expireHoldToken } from "../../api";

import supportEmailLogo from "../../assets/imgs/SupportEmail.svg";
import supportPhoneLogo from "../../assets/imgs/SupportPhone.svg";
import info from "../../assets/imgs/info.svg";
import sorry from "../../assets/imgs/sorry.svg";
import {
  Spinner,
} from "../../design";
import "../../assets/css/eventPageStyle.css";
import Products from "./components/products";
import * as moment from "moment-timezone";
import {Icon} from "antd";
import {AmountDivideByHundred} from "../../helper";

type Props = {
  history: {
    push: Function,
  },
}


const EventPages = (props: Props) => {

  const { match: { params: { eventPageId } }, location: { pathname, search } } = props;
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [eventDetails, setEventDetails] = useState();
  const [mobileView, setMobileView] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [productScreen, setProductScreen] = useState(false);
  const [path, setPath] = useState('');
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            setIsOverflowing(contentRef.current.scrollHeight > contentRef.current.clientHeight);
        }
    }, [eventDetails?.description]);

    const toggleReadMore = () => {
        setIsDescriptionExpanded(!isDescriptionExpanded);
    };


    useEffect(() => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 480) {
      setMobileView(true);
    }
    const storedTime = sessionStorage.getItem("expiryTime");
    const timeLeft = storedTime ? Math.trunc((new Date(parseInt(storedTime, 10)).getTime() - new Date().getTime()) / 1000) : null;
    if (timeLeft && timeLeft <= 0) {
        expiredToken();
    }
  }, []);

  const getEventDataWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
        const value = await getEventPageDetailsById(eventPageId, null);
        if (value && value) {
            setEventDetails(value)
        }

    } catch (e) {
        props.history.push(`${pathname}/error`);
    } finally {
        setShowSpinner(false)
    }
  };

    useEffect(() => {
        if (path) {
            props.history.push(path);
        }
    }, [path]);

  useEffect(() => {
    getEventDataWithoutSearchValue();
  }, [eventPageId, search]);

  function isDark(color) {
    const rgb = getRGB(color);
    const brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return brightness < 128; // Dark if brightness is low
  }

  function getRGB(hex) {
    let r, g, b;
    if (hex.startsWith('#')) {
        const value = hex.length === 7 ? hex.slice(1) : hex.slice(1).repeat(2); // Handle short `#RGB`
        r = parseInt(value.substring(0, 2), 16);
        g = parseInt(value.substring(2, 4), 16);
        b = parseInt(value.substring(4, 6), 16);
    } else {
        [r, g, b] = hex.match(/\d+/g).map(Number); // Handle `rgb(r, g, b)`
    }
    return { r, g, b };
  }


    useEffect(() => {
    if (eventDetails?.primaryColor) {
      document.documentElement.style.setProperty("--primary-color", eventDetails.primaryColor);
      if (isDark(eventDetails.primaryColor)) {
          document.documentElement.style.setProperty('--text-color', '#0C0C0CFF');
      } else {
          document.documentElement.style.setProperty('--text-color', '#000000');
      }
    }
  }, [eventDetails]);

  const products = () => {
    setProductScreen(!productScreen);
  };

  const getOperatingTime = (time) => {
    if (time !== 0) {
        const hours = Math.floor(time / 60);
        const minutes = time % 60;
        let min;
        if (minutes < 10) {
            min = `0${minutes}`;
        } else if (minutes >= 10) {
            min = minutes;
        }
        if (hours > 12) {
            const hr = hours - 12;
            return `${hr}:${min} PM`;
        }
        if (hours === 0) {
            return `${12}:${min} AM`;
        }
        return `${hours}:${min} AM`;
    }
    return '12:00 AM';
  };

  const expiredToken = async () => {
    setProductScreen(false);
    const seats = sessionStorage.getItem('seatsio') ? JSON.parse(sessionStorage.getItem('seatsio')) : undefined;
    if (seats?.holdToken) {
        expireHoldToken(seats.holdToken);
    }

    sessionStorage.removeItem('seatsio');
    sessionStorage.removeItem("expiryTime");
    sessionStorage.removeItem('placedItems-' + eventPageId.replace('eventpage-',''));
    const prefix = 'placedLineItems-' + eventPageId.replace('eventpage-', '');

    Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith(prefix)) {
            sessionStorage.removeItem(key);
        }
    });
  };

  return  (!productScreen ? (
      <>
        <div className="background">
          {/* Fixed Top Section */}
          <div className="fixed-top-section">
              {(() => {
                  const primarySupport = eventDetails?.eventPageSupports?.find(
                      (list) => list.isPrimary
                  );

                  return (
                      <>
                          {/* Heading (optional) */}
                          <div style={{ fontWeight: 'bold', fontSize: '18px' }}>
                              {/* Add any text or heading if needed */}
                          </div>
                          {/* Email and Phone Section */}
                          <div className="d-flex align-items-center gap-20">
                              {primarySupport?.email && (
                                  <div className="d-flex align-items-center gap-8">
                                      <img
                                          alt="Email Icon"
                                          src={supportEmailLogo}
                                          className="icon-height"
                                      />
                                      <span>{primarySupport.email}</span>
                                  </div>
                              )}
                              {primarySupport?.phoneNumber && (
                                  <div className="d-flex align-items-center gap-8">
                                      <img
                                          alt="Phone Icon"
                                          src={supportPhoneLogo}
                                          className="icon-height"
                                      />
                                      <span>{primarySupport.phoneNumber}</span>
                                  </div>
                              )}
                              {eventDetails?.eventPageSupports && eventDetails.eventPageSupports.length > 0 && (
                                  <div className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                                      <img
                                          alt="More Info"
                                          src={info} // Replace this with the URL or import path for your 3-dot or info icon
                                          className="icon-height"
                                          onClick={() => setIsExpanded(!isExpanded)} // Toggle state for expansion
                                      />
                                  </div>
                              )}
                          </div>
                          {/* Event Page Support List */}
                          {isExpanded && (
                              <div className="support-list">
                                  {eventDetails?.eventPageSupports?.map((support, index) => (
                                      <div key={index}>
                                          {/* Support Details */}
                                          <div className="support-item">
                                              { support.name ? <div style={{ fontWeight: 'bold' }}>{support.name}</div> : '' }
                                              { support.email ? <div>{support.email}</div> : '' }
                                              { support.phoneNumber ?<div>{support.phoneNumber}</div> : '' }
                                              { support.designation ?<div>{support.designation}</div> : '' }
                                          </div>

                                          {/* Separator Line */}
                                          {index < eventDetails.eventPageSupports.length - 1 && (
                                              <div className="support-separator"/>
                                          )}
                                      </div>
                                  ))}
                              </div>
                          )}
                      </>
                  );
              })()}
          </div>
          <div className="fixed-logo-section">
            <div className="d-flex align-items-center gap-8">
              {/* Logo */}
              <img
                  alt=""
                  src={eventDetails?.logo}
                  className="logo"
                  style={{ borderRadius: '10%' }}
              />
              {/* Text */}
              <div style={{ fontSize: mobileView ? '10px': '' }}>
                  {eventDetails ? (eventDetails.bannerText ? <div dangerouslySetInnerHTML={{ __html: Buffer.from(eventDetails.bannerText, 'base64').toString('utf8').replaceAll('<br>', '') }} /> : eventDetails.title) : ''}
              </div>
            </div>
          </div>

          <div className="content-section">
            {/* Left side: Image */}
            <div className="banner-image">
              <img
                  id="dynamic-img"
                  src={eventDetails?.banner}
                  alt=""
                  style={{
                    maxWidth: "100%",
                    maxHeight: "64vh",
                    objectFit: "contain",
                    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.5)",
                  }}
              />
            </div>

            {/* Right side: Event details */}
            <div className="details scrollable-content">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h1 className="header-title">
                        {eventDetails?.title}
                    </h1>

                    {eventDetails?.coupon && (
                        <span className="discount-badge" >
                          {eventDetails.coupon.percentageOff
                              ? `${eventDetails.coupon.percentageOff}%`
                              : `$${AmountDivideByHundred(eventDetails.coupon.amountOff)}`
                          } Off
                        </span>
                    )}
                </div>
                <div style={{ marginTop: "1rem", fontSize: "1.0rem", lineHeight: "1.25" }}>
                    {eventDetails?.description && (
                        <div>
                            <div
                                ref={contentRef}
                                style={{
                                    maxHeight: isDescriptionExpanded ? "none" : "7.5rem",
                                    overflowY: isDescriptionExpanded && mobileView ? "auto" : "hidden",
                                    whiteSpace: "pre-wrap",
                                    wordWrap: "break-word",
                                    position: "relative",
                                    color: "var(--text-color)"
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: Buffer.from(eventDetails.description, 'base64')
                                        .toString('utf8')
                                        .replaceAll("<br>", ""),
                                }}
                            />

                            {isOverflowing && (
                                <button className="read-button" onClick={toggleReadMore}>
                                    <u>{isDescriptionExpanded ? "...Read Less" : "...Read More"}</u>
                                </button>
                            )}
                        </div>
                    )}
                </div>
                <div style={{ marginBottom: '10px'}}>
                    {
                        eventDetails && eventDetails.eventDate && (
                            <>
                                <br/>
                                <div className='mr-2 mt-2'>
                                    <h1 className="header-sub-title">
                                        <Icon type='calendar' className="icon-design"/>
                                        Date and time
                                    </h1>
                                    {
                                        eventDetails && eventDetails.eventEndTime ? (
                                            <p style={{ fontSize: '1.25rem', marginLeft: '30px', fontWeight: '550'  }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)} - {getOperatingTime(eventDetails && eventDetails.eventEndTime)}</p>
                                        ) : (
                                            <p style={{ fontSize: '1.25rem', marginLeft: '30px', fontWeight: '550' }}>{eventDetails && moment.utc(eventDetails.eventDate).format('MMM DD, YYYY')}, {getOperatingTime(eventDetails && eventDetails.eventStartTime)}</p>
                                        )
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        eventDetails && eventDetails.address && (
                            <>
                                <br/>
                                <div className='mr-2 mt-2 mb-4'>
                                    <h1 className="header-sub-title">
                                        <Icon type='pushpin' className="icon-design" />
                                        Location
                                    </h1>
                                    <p style={{ fontSize: '1.25rem', marginLeft: '30px', fontWeight: '550' }}>{(eventDetails && eventDetails.address)
                                        ? `${eventDetails.address.street}, 
                                            ${eventDetails.address.city}, 
                                            ${eventDetails.address.state}, 
                                            ${eventDetails.address.postalCode}, 
                                            ${eventDetails.address.country && eventDetails.address.country.alpha3}`
                                        : <>&#8211;</>}</p>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
          </div>


          {/* Fixed Footer */}
          <div className="fixed-footer">
            <button
                className="book-now-btn"
                disabled={!eventDetails}
                onClick={products}
            >
              Book Now
            </button>
          </div>
          <Spinner isOpen={isShowSpinner} />
          <SoldOutModal body={
              <>
                  Sorry! We are sold out for event:{" "}
                  {eventDetails && <span style={{ fontWeight: "bold" }}>{eventDetails.title}</span>}
              </>
          } icon={sorry} isOpen={eventDetails && eventDetails.status === 'SOLD_OUT'} />
          <SoldOutModal body={
              <>
                  Sorry! {eventDetails && <span style={{ fontWeight: "bold" }}>{eventDetails.title}</span>} is Closed.
              </>
          } icon={sorry} isOpen={eventDetails && eventDetails.status === 'DEACTIVATED'} />
        </div>
      </>
      ) : <Products eventDetails={eventDetails} getOperatingTime={getOperatingTime} setPath={setPath} close={products} expiredToken={expiredToken} />
  )
};

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCLR2kMaQ9AHIa_tqsG48hxA9CZ7ullXds'
})(EventPages);
